module.exports = "https://trybtryb-legacy.web.app/img/shadow-bottom-special-mobile.ce364c1a.svg";